import { capitalizeFirstLetter } from "../../utils/string-utils";

type TChipProps = {
  icon?: JSX.Element;
  title: string;
  className?: string;
  paddingClassName?: string;
  onClick?: () => void;
  customStyles?: React.CSSProperties;
  borderRadius?: string;
  titleClassName?: string;
};

export const ChipContainer = ({
  className,
  customStyles,
  onClick,
  paddingClassName,
  children,
  borderRadius = "dr-rounded-4 border border-1",
}: Pick<
  TChipProps,
  "className" | "paddingClassName" | "onClick" | "customStyles"
> & { children: React.ReactNode; borderRadius?: string }) => {
  return (
    <div
      className={`BodyBody2Regular flex items-center ${borderRadius} dr-cursor-pointer ${className} ${paddingClassName} `}
      onClick={onClick}
      style={customStyles}
    >
      {children}
    </div>
  );
};

const Chip = ({
  icon,
  title,
  className = "dr-border-darwin-touch-neutral-200 dr-text-doctor-darwin-neutral-600 dr-bg-darwin-touch-neutral-0",
  paddingClassName = "dr-py-8 dr-px-12",
  onClick,
  customStyles,
  borderRadius = undefined,
  titleClassName = "",
}: TChipProps) => {
  return (
    <ChipContainer
      borderRadius={borderRadius}
      className={className}
      paddingClassName={paddingClassName}
      onClick={onClick}
      customStyles={customStyles}
    >
      {icon ? <span>{icon}</span> : <></>}
      <span className={titleClassName}>{capitalizeFirstLetter(title)}</span>
    </ChipContainer>
  );
};

export default Chip;
